/*
import {
  hf,
  ht,
  useGblz,
//  l,
  f
} from 'lib';
*/
import * as cmFTH from "./_cmFTH"; // 廃止予定
import * as gs from "./_csGbl";
import * as ht from './_ht';
import * as hf from './_hf';
import * as _cm from './_cm';

import * as ihd from './ihd';
import * as ihdI11 from './ihdI11';

export const ilzI11z = () => ({
  i11rz: {},
  i111s: [],
}) as ht.dz;

export const crtI11zAsync = async () => {
  const _gUserz = gs.useGblz('user');
  const _i11z = ilzI11z();
  hf.udtDz(_i11z.i11rz, {
    ... ihd.i('i11r'),
    i11r_31r1f: _gUserz.crt._31rz._fst,
  });
  _i11z.i111s = [];
  return _i11z;
};

/*
//export const loadI11rLsAsync = async (pz: {
  _31r_fst: ht.n,
  i1zrd3100s?: ht.s,
  yearMth?: ht.s,
  i1zrs1100iMnm?: ht.n,
  i10rt1100i?: ht.n, // 単体部屋のみ
  lwrType?: ht.n,
}) => {
//  const _gUserz = useGblz('user');
//  let _cdn = cmFTH.vdd() + ` AND i11r_31r1f=${_gUserz.crt._31rz._fst}`;
  let _cdnI1z1 = cmFTH.vdd(false);
//  _cdnI1z1 += ` AND i1z1i10r1f = {i10r_fst}`;
  _cdnI1z1 += ` AND (
    i1z1i10r1f = {i10r_fst}
    OR i1z1i10r1f IN (
      SELECT
        _fst
      FROM
        i10rs
      WHERE
        ${cmFTH.vdd()}
        AND _key IN (
          SELECT
            i102i10r1k
          FROM
            i102s
          WHERE
            ${cmFTH.vdd()}
            AND i102i10r1f = {i10r_fst}
        )
    )
  )
  `; // 単体部屋＋単体部屋が含まれる複合部屋
  _cdnI1z1 += ` AND (
        (i1z1c4100i = 111 AND i1z1a1100i<{i111a2111i} AND i1z1a1200i>{i111a1111i})
    OR (i1z1c4100i = 112 AND i1z1a1100i<{i111a2112i} AND i1z1a1200i>{i111a1112i})
    OR (i1z1c4100i = 113 AND i1z1a1100i<{i111a2113i} AND i1z1a1200i>{i111a1113i})
    OR (i1z1c4100i = 121 AND i1z1a1100i<{i111a2121i} AND i1z1a1200i>{i111a1121i})
    OR (i1z1c4100i = 122 AND i1z1a1100i<{i111a2122i} AND i1z1a1200i>{i111a1122i})
    OR (i1z1c4100i = 123 AND i1z1a1100i<{i111a2123i} AND i1z1a1200i>{i111a1123i})
    OR (i1z1c4100i = 211 AND i1z1a1100i<{i111a2211i} AND i1z1a1200i>{i111a1211i})
    OR (i1z1c4100i = 212 AND i1z1a1100i<{i111a2212i} AND i1z1a1200i>{i111a1212i})
    OR (i1z1c4100i = 213 AND i1z1a1100i<{i111a2213i} AND i1z1a1200i>{i111a1213i})
    OR (i1z1c4100i = 221 AND i1z1a1100i<{i111a2221i} AND i1z1a1200i>{i111a1221i})
    OR (i1z1c4100i = 222 AND i1z1a1100i<{i111a2222i} AND i1z1a1200i>{i111a1222i})
    OR (i1z1c4100i = 223 AND i1z1a1100i<{i111a2223i} AND i1z1a1200i>{i111a1223i})
  )`;
  const _cdnI1zrd3100s = 
    (pz.i1zrd3100s) ?
      ` AND i1zrd3100s = '${pz.i1zrd3100s}'`
    : (pz.yearMth) ?
      ` AND i1zrd3100s LIKE '${pz.yearMth}%'`
    : '';
  _cdnI1z1 += ` AND i1z1i1zr1k IN (
    SELECT 
      _key 
    FROM 
      i1zrs 
    WHERE 
      ${cmFTH.vdd()} 
      AND i1zr_31r1f = ${pz._31r_fst} 
      AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
      ${_cdnI1zrd3100s}
  )`;

  return await cmFTH.loadLsAsync({
    tgt: 'i11rs',
    cdn: cmFTH.vdd() + ` AND i11r_31r1f=${pz._31r_fst}`,
    fld: '_fst as key, _pfx as pfx, *',
    lwrz: 
      pz?.lwrType == 1 ? // 実績集計表以外
      {
        i111s: {
          tgt: 'i111s',
          cdn: cmFTH.vdd(false) + ` AND i111i11r1k = {i11r_key}`,
          rlcz: {
            i11r_key: 'i11rs._key',
          },
          tailz: {
            odr: '_icn',
          }
        },
        i10rs: {
          tgt: 'i10rs',
          cdn: cmFTH.vdd() + ` AND i10ri11r1f = {i11r_fst}` + (pz.i10rt1100i ? ` AND i10rt1100i = ${pz.i10rt1100i}` : ``),
          rlcz: {
            i11r_fst: 'i11rs._fst',
          },
          tailz: {
            odr: '_icn',
          },
          lwrz: {
            i111s: {
              tgt: 'i111s',
              cdn: cmFTH.vdd(false) + ` AND i111i11r1k = {i11r_key}`,
              rlcz: {
                i11r_key: 'i11rs._key',
              },
              tailz: {
                odr: '_icn',
              },
              lwrz: {
                i1z1s: { // その他１時間を考慮し、開始・終了時刻で集計
                  tgt: 'i1z1s',
                  cdn: _cdnI1z1,
                  rlcz: {
                    i10r_fst: 'i10rs._fst',
                    i111a1111i: 'i111s.i111a1111i',
                    i111a1112i: 'i111s.i111a1112i',
                    i111a1113i: 'i111s.i111a1113i',
                    i111a1121i: 'i111s.i111a1121i',
                    i111a1122i: 'i111s.i111a1122i',
                    i111a1123i: 'i111s.i111a1123i',
                    i111a2111i: 'i111s.i111a2111i',
                    i111a2112i: 'i111s.i111a2112i',
                    i111a2113i: 'i111s.i111a2113i',
                    i111a2121i: 'i111s.i111a2121i',
                    i111a2122i: 'i111s.i111a2122i',
                    i111a2123i: 'i111s.i111a2123i',
                    i111a1211i: 'i111s.i111a1211i',
                    i111a1212i: 'i111s.i111a1212i',
                    i111a1213i: 'i111s.i111a1213i',
                    i111a1221i: 'i111s.i111a1221i',
                    i111a1222i: 'i111s.i111a1222i',
                    i111a1223i: 'i111s.i111a1223i',
                    i111a2211i: 'i111s.i111a2211i',
                    i111a2212i: 'i111s.i111a2212i',
                    i111a2213i: 'i111s.i111a2213i',
                    i111a2221i: 'i111s.i111a2221i',
                    i111a2222i: 'i111s.i111a2222i',
                    i111a2223i: 'i111s.i111a2223i',
                  },
                  lwrz: {
                    i1zrs: {
                      tgt: 'i1zrs',
                      cdn: cmFTH.vdd(false) + ` AND _key = {i1z1i1zr1k}`,
                      rlcz: {
                        i1z1i1zr1k: 'i1z1s.i1z1i1zr1k',
                      },
                      lwrz: {
                        i18rs: {
                          tgt: 'i18rs',
                          cdn: cmFTH.vdd() + ` AND _fst = {i1zri18r1f}`,
                          rlcz: {
                            i1zri18r1f: 'i1zrs.i1zri18r1f',
                          },
                        }
                      }
                    },
                  }
                }
              }
            },
          }
        }
      }
      : pz?.lwrType == 2 ? // 実績集計表 団体種別別集計との整合性、その他１時間の扱いを考慮し、cldType == 1 とは別に集計
      {
        i111s: {
          tgt: 'i111s',
          cdn: cmFTH.vdd(false) + ` AND i111i11r1k = {i11r_key}`,
          rlcz: {
            i11r_key: 'i11rs._key',
          },
          tailz: {
            odr: '_icn',
          }
        },
        i10rs: {
          tgt: 'i10rs',
          cdn: cmFTH.vdd() + ` AND i10ri11r1f = {i11r_fst}`,
          rlcz: {
            i11r_fst: 'i11rs._fst',
          },
          tailz: {
            odr: '_icn',
          },
          lwrz: {
            i1zrs: {
              tgt: 'i1zrs',
              cdn: cmFTH.vdd() + `
                AND i1zrd3100s LIKE '${pz.yearMth}%'
                AND i1zrs1100i >= ${pz.i1zrs1100iMnm ?? -1}
                AND _key IN (
                  SELECT
                    i1z1i1zr1k
                  FROM
                    i1z1s
                  WHERE
                    ${cmFTH.vdd()}
                    AND i1z1i10r1f = {i10r_fst}
              )`,
              rlcz: {
                i10r_fst: 'i10rs._fst',
              },
              lwrz: {
                i1z1s: { // その他１時間を考慮し、開始・終了時刻で集計しない
                  tgt: 'i1z1s',
                  cdn: cmFTH.vdd(false) + `
                    AND i1z1i1zr1k = {i1zr_key}
                    AND i1z1i10r1f = {i10r_fst}
                  `, // i10r に紐づく i1z1 に限定
                  rlcz: {
                    i1zr_key: 'i1zrs._key',
                    i10r_fst: 'i10rs._fst',
                  },
                  lwrz: {
                    i111s: {
                      tgt: 'i111s',
                      cdn: cmFTH.vdd(false) + `
                        AND i111i11r1k = {i11r_key}
                        AND _fst = {i111_fst}
                      `,
                      rlcz: {
                        i11r_key: 'i11rs._key',
                        i111_fst: 'i1z1s.i1z1i1111f',
                      },
                      tailz: {
                        odr: '_icn',
                      },
                    }
                  }
                }
              }

            },

          }
        }
      }
      : undefined,
  });
};
*/

//export const loadI11rLsAsync = async (pz: {
//  _31r_fst: ht.n,
//  i1zrd3100s?: ht.s,
//  yearMth?: ht.s,
//  i1zrs1100iMnm?: ht.n,
//  i10rt1100i?: ht.n, // 単体部屋のみ
//  lwrType?: ht.n,
//}) => {
//  return await cmFTH.loadLsAsync(ihdI11.grtQryLoadI11rLsAsync(_cm.grtUz(), pz));
//};

export const loadI11rDzAsync = async (pz?: {
  i11r_fst: ht.n,
  i1zrd3100s?: ht.s,
  vsn?: ht.n,
}) => {
  const _gUserz = gs.useGblz('user');
  let _cdn = (pz?.vsn && pz?.vsn > 0) ? (cmFTH.vdd(false) + ` AND _vsn = ${pz?.vsn}`) : cmFTH.vdd();
//  let _cdn = cmFTH.vdd() + ` AND i11r_31r1f=${_gUserz.crt._31rz._fst}`;
  _cdn += ` AND i11r_31r1f=${_gUserz.crt._31rz._fst}`;
  if (pz?.i11r_fst) _cdn += ` AND _fst=${pz.i11r_fst}`;
  const _dz = await cmFTH.loadDzAsync({
    tgt: 'i11rs',
    cdn: _cdn,
    lwrz: {
      i111s: {
        tgt: 'i111s',
        cdn: `i111i11r1k = {i11r_key}`,
        rlcz: {
          i11r_key: 'i11rs._key',
        },
      }
    }
  });
  return {
    i11rz: { ... _dz, cldz: undefined },
    i111s: _dz.cldz?.i111s ?? [],
  };
};

export const saveI11rDzAsync = async (pz: {
  i11z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _dz = await cmFTH.ugdDzAsync({
    tgt: 'i11rs',
    dz: {
      ... pz.i11z.i11rz,
    },
    lwrz: {
      i111s: {
        tgt: 'i111s',
        ls: pz.i11z.i111s,
        udtz: {
          i111_31r1f: 'i11rs.i11r_31r1f',
          i111i11r1k: 'i11rs._key',
        }
      },
    }
  });
  return {
    i11rz: { ... _dz, cldz: undefined, }
  };
};